import React from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import { AsyncVideoPlayer } from '../../UI/VideoPlayer/AsyncVideoPlayer';

import styles from './styles.less';

const VideoViewer = ({
  url,
  onCancel,
  visible,
  controls = true,
  modalWithd = '83%',
  closable = true,
  playing = true,
}) => (
  <Modal
    onCancel={onCancel}
    className={styles.modal}
    closable={closable}
    open={visible}
    width={modalWithd}
    footer=""
    style={{
      transition: 'width 0.5s ease 0s',
      paddingBottom: '20px',
      top: '30px',
    }}
    wrapClassName={cn(styles.modal)}
  >
    <div className={styles.wideoWrapper}>
      <AsyncVideoPlayer
        // playing={playing}
        className="react-player"
        url={url}
        width="800px"
        height="450px"
        style={{ display: 'block', backgroundColor: 'black' }}
        controls={controls}
      />
    </div>
  </Modal>
);

export { VideoViewer };
